import React from 'react';
import { SxProps, TableCell, Theme } from '@mui/material';
import { TextV2 } from '@insights-ltd/design-library/components';

type CellProps = {
  keyName: string;
  children: React.ReactNode;
  bold?: boolean;
  secondary?: boolean;
  className?: string;
  size?: 'small' | 'medium';
  isHeader?: boolean;
  sx?: SxProps<Theme>;
};
const bodySx: SxProps<Theme> = {
  maxWidth: 260,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
const headerSx: SxProps<Theme> = (theme) => ({
  height: 44,
  backgroundColor: theme.palette.background.default,
});

const DataTableCell: React.FC<CellProps> = ({
  children,
  isHeader = false,
  bold = false,
  secondary = false,
  size = 'medium',
  className,
  sx = {},
}: CellProps) => {
  return (
    <TableCell
      size={size}
      className={className}
      sx={{
        ...(isHeader ? headerSx : bodySx),
        ...sx,
      }}
    >
      <TextV2
        component="span"
        variant={bold ? 'bodyBold' : 'body1'}
        color={secondary ? 'textSecondary' : 'textPrimary'}
      >
        {children}
      </TextV2>
    </TableCell>
  );
};

export default DataTableCell;
